import { render, staticRenderFns } from "./GenerateRosterDialog.vue?vue&type=template&id=36f9065c&scoped=true&"
import script from "@/views/RosterManagement/GenerateRosterDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/RosterManagement/GenerateRosterDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/RosterManagement/generate-roster-dialog.scss?vue&type=style&index=0&id=36f9065c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f9065c",
  null
  
)

export default component.exports